module.exports = __webpack_public_path__ + "static/media/DSCF9983-3.63ac9b9d.jpg";